export enum EventStatus {
  New = 1,
  Draft = 2,
  Live = 3,
  Complete = 4,
  Canceled = 5,
  Archived = 6
}
